import { render } from "./App.vue?vue&type=template&id=7957442a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7957442a&lang=scss"

import exportComponent from "/codebuild/output/src4207129294/src/github.com/Tippie-de/frontend-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__